import React from "react";
import styled from "styled-components";

import { configAgencyName, devices, logo } from "../../config";
import { appName } from "../../config";

const LogoDiv = styled.div`
  margin-left: 0;
  margin-right: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
`;

const Img = styled.img`
  background-color: ${configAgencyName === ("PoznanPKS" as string) ||
  configAgencyName === ("SmallCities" as string) ||
  configAgencyName === ("PompanoBeach" as string) ||
  configAgencyName === ("Rokbus" as string) ||
  configAgencyName === ("BCT" as string)
    ? "rgba(255, 255, 255, 0.4)"
    : "transparent"};
  width: auto;
  height: ${appName && (appName.includes("PKS") || appName.includes("TC")) ? "74px" : "48px"};
`;

const H1 = styled.h1`
  margin-bottom: 0;
  margin-top: 0;
  margin-left: 0.6rem;
  text-decoration: underline;
  @media only screen and ${devices.fullHD} {
    font-size: 2.2rem;
  }
`;

const LogoContainer = (): JSX.Element => {
  return (
    <React.Fragment>
      <React.Suspense fallback={null}>
        <LogoDiv>
          <Img src={logo} alt="logo" loading="eager" decoding="sync" role="img" />
          <H1>{appName}</H1>
        </LogoDiv>
      </React.Suspense>
    </React.Fragment>
  );
};

export default LogoContainer;
